import {Component, ViewChild} from '@angular/core';
import {NavController, NavParams, Slides, AlertController, ViewController, ToastController} from 'ionic-angular';
import {Http} from "@angular/http";
import {API} from "../../app/services/api.service";
import {ICodeVerificationPayload} from "../../app/interfaces/verification";
import {ISecureToken} from "../../app/interfaces/user";
import {UserService} from "../../app/services/user.service";
import {AnalyticsService} from "../../app/services/analytics.service";

/*
  Generated class for the Register page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-register',
  templateUrl: 'register.html',
  providers: [API, UserService]
})
export class RegisterPage {
  @ViewChild('verificationSlider') slider : Slides;
  public phonenumber : string;
  public verificationCode : string;
  public step = 1;
  constructor(private toastCtrl : ToastController, private viewCtrl : ViewController, private analytics : AnalyticsService, public userService : UserService, public alertCtrl : AlertController, public api : API, public navCtrl: NavController, public navParams: NavParams) {}

  ionViewDidLoad() {
    this.analytics.trackView("Registration");
  }

  verifyPhonenumber(){
    this.api.sendVerificationCode(this.phonenumber).subscribe(
      result => {
        if (result.json() && !result.json().success){
          this.handleError();
          return;
        }
        this.step = this.step + 1
      },
      err => this.handleError()
    );
  }

  verifyCode(){
    this.api.verifyCode(this.verificationCode, this.phonenumber).subscribe(
      result => this.handleCodeVerificationResult(result),
      err => this.handleError()
    );
  }

  dismiss(){
    this.navCtrl.pop();
  }

  handleCodeVerificationResult(result : ICodeVerificationPayload){
    if (result.success){
      this.step = this.step + 1;
      this.saveAccessToken(result.user);
      this.toastCtrl.create({
        message: `Telefonnummer verifiziert!`,
        duration: 2000,
        position: "top"
      }).present();
      this.viewCtrl.dismiss();
    } else {
      let alert = this.alertCtrl.create({
        title: 'Fehler',
        subTitle: 'Dieser Code ist nicht gültig, bitte versuche es erneut...',
        buttons: ['Ok']
      });
      alert.present();
    }
  }

  handleError(){
    let alert = this.alertCtrl.create({
      title: 'Fehler',
      subTitle: 'Dein Code konnte nicht zugeschickt werden. Bitte versuche es erneut oder wende Dich an das Restuarant.',
      buttons: ['Ok']
    });
    alert.present()
  }

  saveAccessToken(payload : ISecureToken){
    payload.verified = true;
    this.userService.setSecureToken(payload);
    this.userService.setAccount(payload);
  }
}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts